import tagTester from './_tagTester.js';

export default tagTester('Date');



//////////////////
// WEBPACK FOOTER
// ./~/underscore/modules/isDate.js
// module id = 761
// module chunks = 0